export default "__VITE_ASSET__fa11c0bd__"